import HttpService from './HttpService';
import ApplicationAction from '../models/ApplicationAction';

export class ApplicationActionService extends HttpService {
  public async load(urlBase: string, locale: string) {
    try {
      return (await this.get<ApplicationAction[]>(`${urlBase}/actions/${locale}.json`)).data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return [];
      }
      return Promise.reject(error);
    }
  }
}

export default new ApplicationActionService();
